import { useAppSelector } from 'shared';

export const usePortfolioEventPageState = (
    () => useAppSelector((store) => store.portfolioEventPage)
);
